
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"id":"a","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 64 64"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticStyle:{"fill":"#231f20"},attrs:{"d":"M32,0C14.33,0,0,14.33,0,32s14.33,32,32,32,32-14.33,32-32S49.67,0,32,0Zm0,60c-15.44,0-28-12.56-28-28S16.56,4,32,4s28,12.56,28,28-12.56,28-28,28Z"}}),_c('path',{staticStyle:{"fill":"#231f20"},attrs:{"d":"M42.3,30.03l-16.06-9.27c-1.52-.88-3.42,.22-3.42,1.97v18.54c0,1.75,1.9,2.85,3.42,1.97l16.06-9.27c1.52-.88,1.52-3.07,0-3.95Z"}})])
          )
        }
      }
    